import { Language } from '@coolblue-development/constants';

type SlugTranslations = Record<Language, string>;
type SlugMap = Record<string, SlugTranslations>;

// Will be extended with more slugs in the future

export const searchSlugTranslations: SlugTranslations = {
  [Language.DUTCH]: 'zoeken',
  [Language.ENGLISH]: 'search',
  [Language.FRENCH]: 'rechercher',
  [Language.GERMAN]: 'suchen'
};

// slug come from the targetPath in the route.mjs
export const LocalizedSlugMap: SlugMap = {
  ['search']: searchSlugTranslations
};
